import { AxiosResponse } from 'axios';
import api from './api';
import { ChangePassUser, CreateUser, DbUser } from '../types/user';

function path(endPath: string = ''): string {
    return `/user${endPath}`;
}

export default class UserService {
    static async getById(userId: number): Promise<AxiosResponse> {
        return api.get(path(`/user/${userId}`));
    }

    static async getByNode(nodeId: number): Promise<AxiosResponse> {
        return api.get(path(`/${nodeId}`));
    }

    static async edit(user: DbUser): Promise<AxiosResponse> {
        return api.post(path(), user);
    }

    static async create(user: CreateUser): Promise<AxiosResponse> {
        return api.put(path(), user);
    }

    static async remove(userId: number): Promise<AxiosResponse> {
        return api.delete(path(`/${userId}`));
    }

    static async adminSetPassword(userId: number, password: string): Promise<AxiosResponse> {
        return api.post(path('/admin-passwd'), { user_id: userId, password });
    }

    static async changePassword(user: ChangePassUser): Promise<AxiosResponse> {
        return api.post(path('/passwd'), user);
    }
}
